/** Why « Créer un jeton » is unavailable, and what a 409 from the API says. */
export function ceilingMessage(maxActive: number): string {
  return `${maxActive} jetons actifs au plus : révoquez-en un pour en créer un autre.`;
}
